import { z } from 'zod';

export const NotificationScalarFieldEnumSchema = z.enum(['id','headline','preview','content','author_id','city_id','published_at','expired_at','created_at','updated_at','last_notified_at','subscription_groups_count','is_draft','channels','classification_id','voiceContent','voiceForceSendAll','voiceAudioResourceId','restrict_to_geotarget_boundary']);

export default NotificationScalarFieldEnumSchema;
